export enum ApprobationExplanationDialogMaxLenghtsEnum {
  REASON_EXPLANATION = 500,
}
